import { all, call, put, takeLatest } from 'redux-saga/effects';
import { retryRequestApiSaga } from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import { Credits } from 'b2b-apps/shop/myAccount/credits/api/Credits';
import { fetchCreditsFulfilled, fetchCreditsRejected } from './actionCreators';
import { FETCH_CREDITS } from './actionTypes';
import type { FetchCreditsAction } from './types';

function* fetchCreditsSaga(action: FetchCreditsAction): Generator<any, any, any> {
  const { pageSize, startItem } = action.payload;

  try {
    const response = yield call(retryRequestApiSaga, Credits.fetch(pageSize, startItem));
    yield put(fetchCreditsFulfilled(response.data));
  } catch (error) {
    yield put(fetchCreditsRejected(parseError(error)));
    yield put(reportError(action.type, error, action.payload));
  }
}

function* creditsSaga(): Generator<any, any, any> {
  yield all([takeLatest(FETCH_CREDITS, fetchCreditsSaga)]);
}

export { creditsSaga };
